import React from 'react'

// material ui
import Box from '@mui/material/Box'

// shared components
import Typography from '@mui/material/Typography'

const NoNopeWarning = props => {
  const { field } = props
  
  return (
    <Box py={2}>
      <Typography color='error.main'>
        Please leave this field blank if there are no other {field}.
      </Typography>
    </Box>
  )
}

export default NoNopeWarning

